import { SkeletonBox } from '@billy/design-system'
import { ReactElement } from 'react'

import * as Styled from './styles'

interface SkeletonCellProps {
  width: number
  colIndex: number
}

export const SkeletonCell = ({ width, colIndex }: SkeletonCellProps): ReactElement => {
  if (colIndex === 0) {
    return <SkeletonBox height={16} width={width} />
  }

  return (
    <Styled.SkeletonWrapper>
      <SkeletonBox height={16} width={width} />
    </Styled.SkeletonWrapper>
  )
}
